"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../../Table.css");
var icons = require("../../../../../styles/att-icons.css");
var Td = /** @class */ (function (_super) {
    __extends(Td, _super);
    function Td(props) {
        var _this = _super.call(this, props) || this;
        _this.isFirstTdInTopRow = _this.isFirstTdInTopRow.bind(_this);
        _this.isFirstTd = _this.isFirstTd.bind(_this);
        _this.isFirstCellEmpty = _this.isFirstCellEmpty.bind(_this);
        _this.accessibility = _this.accessibility.bind(_this);
        return _this;
    }
    Td.prototype.isFirstTdInTopRow = function (el) {
        if (!el) {
            return;
        }
        if (el.cellIndex === 0 && el.parentElement.previousElementSibling === null) {
            return true;
        }
    };
    Td.prototype.isFirstCellEmpty = function (el) {
        if (!el) {
            return null;
        }
        if (this.props.options.rowspan === 1) {
            return false;
        }
        var isChildRow = el.parentElement.getAttribute('data-tr');
        if (el.cellIndex === 0 && el.innerText === '' && isChildRow.indexOf('childRow') !== -1) {
            return true;
        }
        else {
            return false;
        }
    };
    Td.prototype.isFirstTd = function (el) {
        if (!el) {
            return false;
        }
        if (el.cellIndex === 0 && el.innerText) {
            return true;
        }
    };
    Td.prototype.accessibility = function (el) {
        if (!el) {
            return false;
        }
        if (el.innerText) {
            return true;
        }
        return false;
    };
    Td.prototype.render = function () {
        var _this = this;
        var onclick = this.props.events && this.props.events.onToggleCollapse
            ? function (e) { return _this.props.events.onToggleCollapse(e); }
            : null;
        var classes = [styles.cell, this.props.options.className];
        if (this.isFirstCellEmpty(this.tdEl)) {
            classes.push(styles.hiddenTd);
        }
        return (React.createElement("td", { "data-test-id": this.props.testId, className: classes.join(' '), colSpan: this.props.options.colspan, ref: function (el) { return (_this.tdEl = el); }, role: this.isFirstTd(this.tdEl) ? 'rowheader' : null, scope: this.isFirstTd(this.tdEl) ? 'row' : null, "aria-hidden": this.accessibility(this.tdEl) ? false : true, rowSpan: this.isFirstTdInTopRow(this.tdEl) && this.props.options.expanded ? this.props.options.rowspan : null }, this.isFirstTdInTopRow(this.tdEl) && this.props.options.collapsible
            ?
                React.createElement("button", { type: "button", "aria-describedby": "status", "aria-expanded": this.props.options.expanded, className: styles.opener, onClick: onclick },
                    React.createElement("span", { className: styles.hiddenSpoken, id: "status" }, this.props.options.expanded ?
                        ' Click Button to Hide row below'
                        : ' Click Button to Show row below'),
                    React.createElement("i", { className: [icons.attIcon, icons.attIconDown].join(' ') }),
                    " ",
                    this.props.children)
            :
                this.props.children));
    };
    Td.defaultProps = {
        options: {
            className: '',
        },
    };
    return Td;
}(React.Component));
exports.default = Td;
//# sourceMappingURL=Td.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Td/Td.js
// module id = 1369
// module chunks = 8